import { FilterButton, TopToolbar } from 'react-admin';

import { EmployeeActionsDropdown } from '@/view/employees/EmployeesList/components/EmployeeActionsDropdown';

export interface IListActionsProps {
  handleOpenImportCSVModal: () => void;
}

function ListActions({ handleOpenImportCSVModal }: IListActionsProps): JSX.Element {
  return (
    <TopToolbar>
      <FilterButton />
      <EmployeeActionsDropdown handleOpenImportCSVModal={handleOpenImportCSVModal} />
    </TopToolbar>
  );
}

export default ListActions;
